import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import pluralize from 'pluralize';
import { DropdownMenu, TextButton, Typography } from 'seagull';
import { ChevronDown } from 'seagull/icons';
import { getClientReminderDays, getVendorReminderDays } from '~/business-logic/notificationSettings';
import { daysToMinutes, isDays, minutesToDays, Tab } from '../../../NotificationSettings.utils';
import { GetCadenceDaysDropdownTID } from './CadenceDaysDropdown.testIds';
export const CadenceDaysDropdown = (param)=>{
    let { selectedTab, minutes, onChange } = param;
    var _dayOptions_;
    const { CadenceDaysDropdownTestIds: testIds } = useMemo(()=>GetCadenceDaysDropdownTID(), []);
    const dayOptions = selectedTab === Tab.Vendor ? getVendorReminderDays() : getClientReminderDays();
    const triggerLabel = minutes != null && isDays(minutes) ? pluralize('day', minutesToDays(minutes), true) : minutes != null ? pluralize('minute', minutes, true) : pluralize('day', (_dayOptions_ = dayOptions[0]) !== null && _dayOptions_ !== void 0 ? _dayOptions_ : 1, true);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        hAlign: "left",
        maxHeight: "50%",
        target: /*#__PURE__*/ _jsx(TextButton, {
            weight: "bold",
            underline: "none",
            suffixIcon: /*#__PURE__*/ _jsx(ChevronDown, {}),
            bi: {
                name: 'cadence_days'
            },
            testId: testIds.Trigger(),
            children: triggerLabel
        }),
        children: dayOptions.map((days)=>/*#__PURE__*/ _jsx(DropdownMenu.Item, {
                bi: {
                    name: 'notification_cadence_days_option'
                },
                onClick: ()=>onChange(daysToMinutes(days)),
                testId: testIds.Option(days),
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: pluralize('day', days, true)
                })
            }, days))
    });
};
